import { LocalSubscriptionPlan, LocalUser } from "@/modeltypings";

export function localUserHasPlanFromUserPlan(
  currentPlan: LocalSubscriptionPlan
) {
  return currentPlan != LocalSubscriptionPlan.NO_PLAN;
}

export function localUserHasPlan(user: LocalUser) {
  return localUserHasPlanFromUserPlan(user.currentPlan);
}
